import createVueApp from '@/common/create_app'

Styxie.Initializers.FacebookAccounts = {
  index: async(props) => {
    const { default: FacebookAccountsIndex } = await import('@/vue_widgets/facebook_accounts/index.vue')
    createVueApp(FacebookAccountsIndex, { props })
  }
}
